var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#F2F4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8238 40C21.2788 40 21.6476 39.6312 21.6476 39.1762C21.6476 34.4332 25.4926 30.5883 30.2355 30.5883C34.9785 30.5883 38.8234 34.4332 38.8234 39.1762C38.8234 39.6312 39.1922 40 39.6472 40C40.1022 40 40.471 39.6312 40.471 39.1762C40.471 33.5233 35.8884 28.9407 30.2355 28.9407C24.5826 28.9407 20 33.5233 20 39.1762C20 39.6312 20.3688 40 20.8238 40Z",
    fill: "#ABA9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6476 40.0002H20.8242V38.3525H39.6476V40.0002Z",
    fill: "#ABA9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2358 19.6477C32.5746 19.6477 34.4705 21.5436 34.4705 23.8823C34.4705 26.2211 32.5746 28.117 30.2358 28.117C27.8971 28.117 26.0012 26.2211 26.0012 23.8823C26.0012 21.5436 27.8971 19.6477 30.2358 19.6477ZM30.2358 18C33.4845 18 36.1181 20.6336 36.1181 23.8823C36.1181 27.1311 33.4845 29.7646 30.2358 29.7646C26.9871 29.7646 24.3535 27.1311 24.3535 23.8823C24.3535 20.6336 26.9871 18 30.2358 18Z",
    fill: "#ABA9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/AvatarDefault.fcfa3debc938ad37ebea215dca9a6d3a.svg";
export { ForwardRef as ReactComponent };